import {AlertTriangle} from "react-feather";
import {TabHasError} from "../hooks/utils";

const TabLabel = (props) => {
    const {icon, label, slug, errors} = props




    return (
        <>
            {icon} {label}
            {TabHasError(slug, errors) && <AlertTriangle className="tab-error"/> }
        </>
    )
}

export default TabLabel